import {
  DOWNLOAD_FILE_S3_WRAP,
  // Multiples
  POST_MULTIPLES_FILES,
  DELETE_MULTIPLES_FILES,
} from "./constants"


export function downloadFileEtlAction(payload) {
  return {
    type: DOWNLOAD_FILE_S3_WRAP,
    payload: payload,
  }
}

// Multiples
export function postMultiplesFilesEtlAction(payload) {
  return {
    type: POST_MULTIPLES_FILES,
    payload: payload,
  }
}

export function deleteMultiplesFilesEtlAction(payload) {
  return {
    type: DELETE_MULTIPLES_FILES,
    payload: payload,
  }
}
